import { render, staticRenderFns } from "./FiltroId.vue?vue&type=template&id=0b55edb1&"
import script from "./FiltroId.vue?vue&type=script&lang=ts&"
export * from "./FiltroId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports